'use client';

import React, { useState, type JSX } from 'react';
import createLead from '../../lib/client/create-lead';
import { useCampaignTracker } from '../client/campaign-tracker';

export default function NewsLetterSignUpForm(): JSX.Element {
  const [state, setState] = useState({
    email: '',
    subscribed: false,
    loading: false,
    privacyPolicy: false,
  })

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    setState((s) => ({
      ...s,
      email: value,
    }));
  };

  const trackingInfo = useCampaignTracker();

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (state.loading) { return; }
    setState((prevState) => ({ ...prevState, loading: true }))

    createLead({
      type: 'blog-subscription',
      details: {
        email: state.email,
      },
      tracking: trackingInfo,
    }).then(() => {
      setState((prevState) => ({ ...prevState, loading: false, subscribed: true, email: '' }));
    }, () => {
      setState((prevState) => ({ ...prevState, loading: false }))
    })
  }

  return (
    <div className="py-10">
      <hr className="border-y-2 md:border-slate-100 mb-20" />

      <p className="text-center text-4xl font-bold mb-8">
        Subscribe to The Salon App blog
      </p>

      <div className="max-w-lg mx-auto">
        {state.subscribed ? (
          <div className="bg-success/10 font-medium rounded-lg mt-4 h-16 grid place-items-center">
            Thanks for subscribing!
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="flex gap-4">
              <input
                required
                autoComplete="email"
                className="input input-lg bg-gray-100 w-full"
                placeholder="Your email address"
                value={state.email}
                onChange={handleEmailChange}
                name="email"
              />

              <button
                type="submit"
                className={`btn btn-accent btn-outline btn-lg ${state.loading ? 'loading' : ''}`}>
                Subscribe
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
